import { useEffect, useState } from 'react';
import {
  getEmptyMaintenanceNotice,
  subscribeToMaintenanceNotice,
} from '../../lib/site/maintenanceNoticeQueries';

/**
 * Global site warning banner shown below the header when published by admin.
 */
export function SiteMaintenanceBanner() {
  const [maintenanceNotice, setMaintenanceNotice] = useState(getEmptyMaintenanceNotice);

  useEffect(() => {
    return subscribeToMaintenanceNotice((nextNotice) => {
      setMaintenanceNotice(nextNotice);
    });
  }, []);

  if (!maintenanceNotice.isPublished || !maintenanceNotice.message) {
    return null;
  }

  return (
    <div className="notice warning site-maintenance-banner" role="status" aria-live="polite">
      <strong>Maintenance Notice:</strong> {maintenanceNotice.message}
    </div>
  );
}
